module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-center1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ALSO BY DAVID WILLIAMS")])])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "fm-center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A People’s History of the Civil War: Struggles for the Meaning of Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Plain Folk in a Rich Man’s War: Class and Dissent in Confederate Georgia")]), _c('br'), _vm._v("(with Teresa Crisp Williams and David Carlson)")]), _vm._v(" "), _c('p', {
    staticClass: "fm-center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Johnny Reb’s War: Battlefield and Homefront")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rich Man’s War: Class, Caste, and Confederate Defeat in the Lower"), _c('br'), _vm._v("Chattahoochee Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Georgia Gold Rush: Twenty-Niners, Cherokees, and Gold Fever")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gold Fever: America’s First Gold Rush")]), _c('br'), _vm._v("(with Ray C. Rensi)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-366793e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Frontmatter.vue
// module id = 57
// module chunks = 0